import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const importGreenWallet = (investor_id, mnemonic) => request.post(`${API_BASE_URL}/blockchain/green-wallet/import`, { investor_id, mnemonic })

export default importGreenWallet;